export const isItemInArray = (arr, item) => {
  return arr?.includes(item);
};
